/**
 * @fileoverview Sentry-wrapped React Router v6 Routes component for error tracking.
 */

import {Routes} from "react-router-dom";
import * as Sentry from "@sentry/react";

/**
 * React Router Routes component wrapped with Sentry error tracking.
 * Automatically captures routing errors and performance data.
 */
export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
